
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCommencementNotificationData, getComplianceDeclarationData, getDutyHolderData, getInitialNoticeData } from "../../Api/BuildingInspectorService/BuildingInspectorService";
import { mapInitialNotice } from "../Types/InitialNotice/InitialNoticeTypes";
import { mapDutyHolderDetails } from "../Types/DutyHolderDetails/DutyHolderDetailsTypes";
import { mapCommencementNotification } from "../Types/CommencementNotification/CommencementNotificationTypes";

// get intial notice data
export const getInitialNoticeByFolderId = createAsyncThunk('getInitialNoticeData', async (id:number, { rejectWithValue }) => {
  try {
    // api
    const response = await getInitialNoticeData(id);
    if (response.status) {
      return mapInitialNotice(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});


// get dutyholder details
export const getDutyHolderDetailsByFolderId = createAsyncThunk('getDutyHolderData', async (id:number, { rejectWithValue }) => {
  try {
    // api
    const response = await getDutyHolderData(id);
    if (response.status) {
      return mapDutyHolderDetails(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});



// get intial notice data
export const getCommencementNotificationByFolderId = createAsyncThunk('getCommencementNotificationData', async (id:number, { rejectWithValue }) => {
  try {
    // api
    const response = await getCommencementNotificationData(id);
    if (response.status) {
      return mapCommencementNotification(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});


// get dutyholder details
export const getComplianceDeclarationFolderId = createAsyncThunk('getComplianceDeclaration', async (id:number, { rejectWithValue }) => {
  try {
    // api
    const response = await getComplianceDeclarationData(id);
    if (response.status) {
      return mapDutyHolderDetails(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});




